import {DataStatus} from 'platform/components';

import {useCallback} from 'react';

import {isNilOrEmpty} from 'ramda-adjunct';

import {
  useGetAutostacjaSvConnectorConfigQuery,
  usePatchAutostacjaSvConnectorConfigMutation,
} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsStackItemProps, SettingsStackItems} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

export type FormValues = {
  subscriptionKey: string;
};

export function AutostacjaSettingsList() {
  const {
    data: autostacjaQueryData,
    isLoading: isAutostacjaQueryLoading,
    isError: isAutostacjaQueryError,
    refetch: autostacjaQueryRefetch,
  } = useGetAutostacjaSvConnectorConfigQuery();

  const [patchAutostacjaMutation] = usePatchAutostacjaSvConnectorConfigMutation();

  const handleSwitchChange = useCallback(
    (
      mutation: typeof patchAutostacjaMutation,
      enabled: boolean,
      refetch?: typeof autostacjaQueryRefetch
    ) => {
      mutation({body: {enabled}})
        .unwrap()
        .then(() => {
          refetch?.();
        })
        .catch(handleApiError);
    },
    []
  );

  const items: SettingsStackItemProps[] = [
    {
      cyId: testIds.settings.autostacjaSettings('link'),
      title: i18n.t('page.integrations.labels.autostacja'),
      url: settingsRoutes.autostacjaSettingsSubscriptionKey,
      switchProps: {
        name: 'autostacja-subscription-key',
        // This condition was required by the original acceptance criteria
        // isDisabled: !autostacjaQueryData?.credentials?.subscriptionKey,
        isDisabled: false,
        value: autostacjaQueryData?.enabled ?? false,
        onChange: (enabled) =>
          handleSwitchChange(patchAutostacjaMutation, enabled, autostacjaQueryRefetch),
      },
    },
  ];

  return (
    <DataStatus
      isLoading={isAutostacjaQueryLoading}
      isError={isAutostacjaQueryError}
      isEmpty={isNilOrEmpty(items)}
      minHeight={50}
    >
      <SettingsStackItems items={items} />
    </DataStatus>
  );
}
